// extracted by mini-css-extract-plugin
module.exports = {"starContainer":"_8fhYe","imageIcon":"_1Rj62","sm":"_1fqEv","md":"Sr-Ls","lg":"_2iZmt","star-icon-button":"_3I_KR","tooltip-container":"_2MInk"};